import { Form } from 'antd';
import authApi from 'api/auth';
import { useAppSelector, useAppTranslation } from 'app/hooks';
import VerticalForm from 'components/Form/VerticalForm';
import { showSuccessModal } from 'components/Modals/CommonModals';
import { useHandleResponseError } from 'hooks/useHandleResponseError';
import { ChangeNameFormRequestModel } from 'models/auth';
import React, { useEffect, useMemo, useState } from 'react';
import { AiOutlineCloseCircle } from 'react-icons/ai';
import FieldError from 'components/FormField/FieldError';
import TextField from 'components/FormField/TextField';
import { HiMiniIdentification } from 'react-icons/hi2';
import useUserDetail from 'hooks/useUserDetail';
import { selectCurrentUser } from 'redux/userSlice';

interface ChangeNamePageProps {
  isShow: boolean;
  closePage: () => void;
}

const ChangeNamePage: React.FunctionComponent<ChangeNamePageProps> = ({ isShow, closePage }) => {
  const [form] = Form.useForm();
  const t = useAppTranslation();
  const handleResponseError = useHandleResponseError();
  const { getUser } = useUserDetail();
  const [haveError, setHaveError] = useState<boolean>(false);
  const selectedCurrentUser = useAppSelector(selectCurrentUser)
  const onClosePageClick = () => {
    form.resetFields();
    closePage();
  };
  const handleFieldsChange = () => {
    setHaveError(form.getFieldsError().some((error) => error.errors.length));
  };
  const onSubmit = async (value: ChangeNameFormRequestModel) => {
    const { ok, error } = await authApi.changeName(value);
    if (ok) {
      const onOk = () => {
        onClosePageClick();
        getUser();
      };
      showSuccessModal({
        title: t('changeName.success.title'),
        content: t('changeName.success.message'),
        onOk,
      });
    }
    if (error) {
      handleResponseError(error);
    }
  };

  useEffect(() => {
    form.setFieldValue('newFirstName',selectedCurrentUser?.firstName)
    form.setFieldValue('newLastName',selectedCurrentUser?.lastName)
  },[selectedCurrentUser,isShow])

  const disableButon = useMemo(() => {
    if(form.getFieldValue('newFirstName') === selectedCurrentUser?.firstName && form.getFieldValue('newLastName') === selectedCurrentUser?.lastName) {
      return true
    }
    return false
  },[form.getFieldValue('newFirstName'), form.getFieldValue('newLastName')])

  return (
    <div className={`overlay center-content-col primary-text-color ${isShow ? 'show' : 'hidden'}`}>
      <div className="change-form">
        <div className="auth-form__header">
          <h2> {t('changeName.title')}</h2>
        </div>
        <button className="btn-close" onClick={onClosePageClick} type="button">
          <AiOutlineCloseCircle />
        </button>
        <VerticalForm
          className="auth__change-password"
          name="changeName"
          form={form}
          onFinish={onSubmit}
          onFieldsChange={handleFieldsChange}
        >
          <TextField
            name="newFirstName"
            placeholder={t('placeholder.enterFirstname')}
            prefix={<HiMiniIdentification />}
            rules={[
              {
                required: true,
                message: <FieldError message={t('errors.firstName')} />,
              },

              {
                max: 50,
                message: <FieldError message={t('errors.firstNameLeng')} />,
              },
            ]}
            maxLength={50}
          />
          <TextField
            name="newLastName"
            placeholder={t('placeholder.enterLastname')}
            prefix={<HiMiniIdentification />}
            rules={[
              {
                required: true,
                message: <FieldError message={t('errors.lastName')} />,
              },

              {
                max: 50,
                message: <FieldError message={t('errors.lastNameLeng')} />,
              },
            ]}
            maxLength={50}
          />
          <button className={`${haveError || disableButon ? 'disabled' : ''} button submit-button`} type="submit" 
          disabled={haveError || disableButon}>
            Comfirm
          </button>
        </VerticalForm>
      </div>
    </div>
  );
};

export default ChangeNamePage;
